// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bf23ce8406c42ed7998e","655":"7a7e90d81523c43c1018"}[chunkId] + ".js";
};